<template>
    <el-card class="assign-coach-table">
        <div class="search-divp flex items-center">
            <el-input class="search-input"
                v-model="form.keyword"
                :placeholder="$t('Reception.Second.search_placeholder')">
            </el-input>
            <div class="pl-6">
                <el-button type="primary" @click="fetchData">{{ $t('Common.search') }}</el-button>
                <el-button type="primary" @click="handleReset">{{ $t('Common.clear') }}</el-button>
            </div>
        </div>
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
            >
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="id" :label="$t('Card.client_id')" align="center" width="60px" v-if="false"/>
            <el-table-column prop="coachProtectDays" :label="$t('Reception.Second.day')" align="center" />
            <el-table-column prop="mshpAt" :label="$t('Member.enter_date')" align="center" width="100px"/>
            <el-table-column prop="mshpExpiredAt" :label="$t('Member.Time.end')" align="center" width="100px"/>
            <el-table-column prop="coachNickname" :label="$t('Common.coach')" align="center" width="100px"/>
            <el-table-column prop="coachFollowCount" :label="$t('Member.Follow.coach_ci')" align="center" width="100px"/>
            <el-table-column prop="coachFollowAt" :label="$t('Member.Follow.last_date')" align="center" width="100px"/>
            <el-table-column prop="name" :label="$t('Card.client_name')" align="center"/>
            <el-table-column prop="gender" :label="$t('Common.gender')" align="center" width="50px"/>
            <el-table-column prop="phone" :label="$t('Common.phone_number')" align="center" width="110px"/>
            <el-table-column prop="coachFollowStatus" :label="$t('Member.Follow.table_coach_status')" align="center" />
            <el-table-column prop="lessonCountAvailable" :label="$t('Lesson.wei_guoqi')" align="center" width="120px"/>
            <el-table-column prop="lessonCountExpired" :label="$t('Lesson.yi_guoqi')" align="center" width="120px"/>
            <el-table-column prop="cardNames" :label="$t('Card.service')" align="center" />
            <el-table-column prop="mshpSalesNickname" :label="$t('Common.saler')" align="center" width="100px"/>
            <el-table-column prop="salesFollowCount" :label="$t('Common.Number_sales_follow-up')" align="center" width="100px"/>
            <el-table-column prop="clientTagNames" :label="$t('Client.Add.customer_label')" align="center"/>
            <el-table-column prop="activeName" :label="$t('Client.Add.status')" align="center"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-center"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>

        <!-- 分配教练弹窗 -->
        <el-dialog :visible.sync="visible" :title="$t('Board.Flow.select_the_coaches')" left>
            <p style="font-size:13px;">
                {{ $t('Client.SelectedPotentCustomers') }}{{clients.length}}{{ $t('Client.name_tobeassigned') }}
            </p>
            <el-table
                border
                v-if="coaches"
                :data="coaches"
                class="my-4"
                v-loading="loading"
                highlight-current-row
                @current-change="coachSelectChange"
            >
                <el-table-column prop="id" :label="$t('Course.coachId')" align="center" v-if="false"/>
                <el-table-column prop="nickname" :label="$t('Common.coach')" align="center"/>
                <el-table-column prop="fullClientCount" :label="$t('Member.member')" align="center"/>
            </el-table>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button @click="submit" type="primary">{{ $t('Course.allot') }}</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    props: ['activeName'],
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            clients: [],
            visible: false,
            selectCoach: {},
            coachForm: {
                clientIds: [],
                staffId: '',
            },
            coaches: [],
            form: {
                keyword: '',
                page: 1,
            },
            totalCount: 0,
            potentialClientCount: 0,
            fullPercent: '',
            fullClientCount: 0,
            loading: false,
            tableData: [],
            clientIds: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            is_collapse: false,
        };
    },
    computed: {},
    mounted() {},
    watch: {
        activeName(val) {
            if (val === 'sixth') this.fetchData();
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('client/assign-coach', {
                params: { ...this.form },
            })
                .then(res => {
                    this.tableData = res.content;
                    this.pagination.total = res.totalElements;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchCoach() {
            this.loading = true;
            API.get('client/coach-client-count')
                .then(res => {
                    this.coaches = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        say(data) {
            this.form = data;
            this.fetchData();
        },
        handleReset() {
            this.form = {};
            this.fetchData(1);
        },
        handleSelectChange(val) {
            this.clientIds = val.map(el => el.id);
            this.clients = val;
            this.$emit('listenClientIds', this.clients);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        submit() {
            if (this.validSelect()) {
                this.loading = true;
                API.post('client/assign-coach', this.coachForm).then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                }).finally(() => {
                    this.loading = false;
                    this.visible = false;
                    this.fetchData();
                }).catch(err => {
                    $ele.$message.error(err);
                });
            }
        },
        validSelect() {
            if (!this.selectCoach || !this.selectCoach.id) $ele.$message.warning(this.$t('Message.Select_A_Coach'));
            else {
                this.coachForm.staffId = this.selectCoach.id;
                this.coachForm.clientIds = this.clientIds;
                return true;
            }
        },
        coachSelectChange(val) {
            this.selectCoach = val;
        },
        handleAssign() {
            this.fetchCoach();
            this.visible = true;
        },
    },
    created() {
        if (this.activeName === 'sixth') {
            this.fetchData();
        }
    },
};
</script>
<style lang="scss">
.assign-coach-table {
    .el-dialog {
        background: #fff;
        box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
        min-width: 258px;
        max-height: 800px;
    }
    .el-dialog__body {
        max-height: 700px;
    }
    .el-dialog__title {
        font-size: 13px;
        padding: 0 5px 15px 5px;
    }
    .el-dialog__header {
        line-height: 40px;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .title {
        width: 98%;
    }
    .title-3a {
        height: 30px;
        color: grey;
        line-height: 50px;
        font-size: 12px;
        font-weight: 400;
    }
    .search-divpp {
        position: absolute !important;
        left: 20px;
        top: 10px;
        bottom: 20px;
        padding-bottom: 15px;
    }
    .search-input {
        width: 300px;
    }
}
</style>
